/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  manufacturerIdLabel,
  nameLabel,
  rebateProgramLabel,
  quarterRangeLabel,
  NDCLabel,
  URAUsedLabel,
  accountReceivableNDCActivityLabel,
  drugNameLabel,
  NDCStatusLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { accountReceivableNDCActivityColumns } from '../tablehead';
import {
  activityTypePrincipal,
  activityTypeInterest,
  ndcActivityFirstLoadAction,
} from './store/actions';
import { ACC_REC_NDC_ACTIVITY } from './store/actiontypes';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import ActionDropDownComp from '../ActionDropdownComp';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RedTextRenderComp from '../RedTextRenderComp';
import { getExistingCorrLinkIds } from '../ARCommonFunctions';

const AccRecNDCActivity = (props) => {
  const dispatch = useDispatch();

  const activity_type_principal = useSelector(
    (state) =>
      state?.sharedState?.AccRecNDCActivityReducer?.activity_type_principal
  );

  const activity_type_interest = useSelector(
    (state) =>
      state?.sharedState?.AccRecNDCActivityReducer?.activity_type_interest
  );

  const ndc_activity = useSelector(
    (state) => state?.sharedState?.AccRecNDCActivityReducer?.ndc_activity
  );

  const ndc_activity_head = useSelector(
    (state) => state?.sharedState?.AccRecNDCActivityReducer?.ndc_activity_head
  );

  const viewPmtActInd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.viewPmtActInd
  );
  const viewIntActInd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.viewIntActInd
  );
  const modificationFromAr = useSelector(
    (state) => state?.sharedState?.AccRecNDCDetailReducer?.modificationFromAr
  );
  const ndcActFirstLoad = useSelector(
    (state) => state?.sharedState?.AccRecNDCActivityReducer?.ndcActFirstLoad
  );

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [load, setLoad] = React.useState(false);
  const [tblRecord, setTblRecord] = React.useState([]);
  const [modificationFromArState, setModificationFromArState] = React.useState(
    {}
  );
  const commentsData = (status, id) => {
    setShowComments(status);
    setCorrLinkId(id);
  };

  const selectedRebate = (val) => {
    // setArNavRebate(val.rebateProgramCd);
    // let payload = {
    //   planType: val.planTypeCd,
    //   mfgId: manu_arfld.mfgId,
    //   startQtr: manu_arfld.startQtr,
    //   endQtr: manu_arfld.endQtr,
    //   useOfficialURA: manu_arfld.useOfficialURA,
    //   rebateProgram: val.rebateProgramCd,
    // };
    // dispatch(
    //   getManuARForSglRpc(payload, {
    //     ...manu_arfld,
    //     ...payload,
    //     pgmInfo: `${val.rebateProgramCd} | ${val.shortDescr}`,
    //   })
    // );
    // setLoad(true);
  };

  const commentsCallFn = async () => {
    if (ndc_activity) {
      const val = ndc_activity.map((o) => o.corrLinkId);
      const result = await dispatch(getExistingCorrLinkIds(val));
      const newVal = ndc_activity.map((obj) => {
        obj.cc_COMMENTS_EXIST = 0;
        if (result.indexOf(obj.corrLinkId) !== -1) obj.cc_COMMENTS_EXIST = 1;
        return obj;
      });
      dispatch({ type: ACC_REC_NDC_ACTIVITY, payload: newVal });
      if (gridApi) gridApi.redrawRows();
    }
  };

  // ag-grid frame work component
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      return (
        <>
          <div className="tdCell dib icon-btn-group">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
            >
              <Button
                onClick={() => commentsData(true, cellInfo?.data?.corrLinkId)}
                variant="text"
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn"
              >
                {!cellInfo?.data?.cc_COMMENTS_EXIST ? (
                  <SVGComponent iconName="Icon-comment-grey" />
                ) : (
                  <SVGComponent iconName="Icon-comment" />
                )}
              </Button>
            </OverlayTrigger>
          </div>
          <ActionDropDownComp
            data={cellInfo}
            loadfn={setLoad}
            displayBy="NDCActivity"
            selectPgm
            selectedRebate={selectedRebate}
          />
        </>
      );
    },
    redTextRenderer: (cellInfo) => {
      return <RedTextRenderComp data={cellInfo} />;
    },
    redTextWithoutDollar: (cellInfo) => {
      let value = '';
      if (cellInfo?.colDef?.headerName === 'Units Change') {
        value = cellInfo.data.unitChange;
      }
      if (value && parseFloat(value) < 0)
        return (
          <span style={{ color: '#eb0000' }}>
            {`(${parseFloat(-value).toFixed(3)})`}
          </span>
        );
      return <span>{value}</span>;
    },
    CheckboxRenderer: (cellInfo) => {
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            value={cellInfo?.data?.disputeResolutionInd === 1}
            disabled
            onChange={(e, val) => {}}
            checked={cellInfo?.data?.disputeResolutionInd === 1}
          />
        </div>
      );
    },
  };
  const onGridReady = (params) => {
    setGridApi(params?.api);
    params.api.refreshCells();
  };

  React.useEffect(() => {
    if (!ndcActFirstLoad) {
      dispatch(activityTypePrincipal(!!viewPmtActInd));
      dispatch(activityTypeInterest(!!viewIntActInd));
      commentsCallFn();
      dispatch(ndcActivityFirstLoadAction(true));
    }
    setLoad(false);
  }, []);

  React.useEffect(() => {
    if (ndc_activity) {
      let tblRecordData = [];
      if (activity_type_principal && !activity_type_interest) {
        tblRecordData = ndc_activity.filter((item) => {
          return !item.drugActivityTypeCd?.startsWith('I');
        });
      } else if (!activity_type_principal && activity_type_interest) {
        tblRecordData = ndc_activity.filter((item) => {
          return item.drugActivityTypeCd?.startsWith('I');
        });
      } else if (!activity_type_principal && !activity_type_interest) {
        tblRecordData = [];
      } else if (activity_type_principal && activity_type_interest) {
        tblRecordData = ndc_activity;
      }

      setTblRecord(tblRecordData);
      // if (gridApi) gridApi.api.refreshCells();
    }
  }, [ndc_activity, activity_type_principal, activity_type_interest]);

  React.useEffect(() => {
    const modification = modificationFromAr?.find(
      (item) => item.drugSeqNum === ndc_activity_head?.drugSeqNum
    );
    setModificationFromArState(modification);
  }, [modificationFromAr]);

  let firstInfo = `Manufacturer ID: ${ndc_activity_head?.mfgId}`;
  let secondInfo = `Quarter Range: ${ndc_activity_head?.quarter}`;
  let thirdInfo = `Rebate Program: ${ndc_activity_head?.rebateProgram}`;
  let fourthInfo = `Manufacturer Name: ${ndc_activity_head?.mfgName}`;
  let fifthInfo = `Drug Name: ${ndc_activity_head?.drugName}`;
  let sixthInfo = `NDC Status: ${ndc_activity_head?.ndcStatus}`;
  let seventhInfo = `URA Used: ${ndc_activity_head?.URAUsed}`;

  return (
    <div className="tabs-container ARScreen" data-testid="accRec-ndc-activity">
      <CustomSeparator
        parent1="Research"
        parent2="Accounts Receivable NDC Activity"
      />
      <Spinner load={load} />
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-12">
              <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="manufacturerId"
                        label={manufacturerIdLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.mfgId}
                      />
                    </div>
                  </div>
                  <div className="col-3col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="name"
                        label={nameLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.mfgName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="quarter"
                        label={quarterRangeLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.quarter}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="rebateProgram"
                        label={rebateProgramLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.rebateProgram}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="URAUsed"
                        label={URAUsedLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.URAUsed}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="NDC"
                        label={NDCLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.ndc}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="drugName"
                        label={drugNameLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.drugName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="mui-custom-form">
                      <TextField
                        id="NDCStatus"
                        label={NDCStatusLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={ndc_activity_head?.ndcStatus}
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-6">
              <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
                <legend className="same-font-family">
                  Modification From A/R
                </legend>
                <div className="row">
                  <div className="col-6">
                    <div className="mui-custom-form">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        disabled
                        label="Unit"
                        value="unit"
                        onChange={(e, val) => {}}
                        checked={
                          !!(
                            modificationFromArState &&
                            modificationFromArState.unit
                          )
                        }
                        data-testid="unit-check-box-change"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mui-custom-form">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Interest"
                        disabled
                        value="interest"
                        onChange={(e, val) => {}}
                        checked={
                          !!(
                            modificationFromArState &&
                            modificationFromArState.interest
                          )
                        }
                        data-testid="interest-check-box-change"
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-6">
              <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
                <legend className="same-font-family">A/R Activity Types</legend>
                <div className="row">
                  <div className="col-6">
                    <div className="mui-custom-form">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Principal"
                        value={activity_type_principal || false}
                        onChange={(e, val) => {
                          dispatch(activityTypePrincipal(val));
                        }}
                        checked={activity_type_principal || false}
                        data-testid="principal-check-box-change"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mui-custom-form">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Interest"
                        value={activity_type_interest || false}
                        onChange={(e, val) => {
                          dispatch(activityTypeInterest(val));
                        }}
                        checked={activity_type_interest || false}
                        data-testid="ar-interest-check-box-change"
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell ">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={accountReceivableNDCActivityColumns}
            rowData={tblRecord?.map((prop) => {
              prop.activityUnits = prop.activityUnits
                ? parseFloat(prop.activityUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              prop.unitChange = prop.unitChange
                ? parseFloat(prop.unitChange).toFixed(3)
                : parseFloat(0).toFixed(3);
              prop.paidUnits = prop.paidUnits
                ? parseFloat(prop.paidUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              prop.disputedUnits = prop.disputedUnits
                ? parseFloat(prop.disputedUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              prop.reimburseAmt = prop.reimburseAmt
                ? prop.reimburseAmt
                : parseFloat(0).toFixed(2);
              prop.overridenChangeAmount = prop.overridenChangeAmount
                ? prop.overridenChangeAmount
                : parseFloat(0).toFixed(2);
              prop.overridenRoaChangeAmt = prop.overridenRoaChangeAmt
                ? prop.overridenRoaChangeAmt
                : parseFloat(0).toFixed(2);
              prop.updateDt = prop.updateDt
                ? moment(prop.updateDt).format('MM/DD/YYYY')
                : prop.updateDt;
              prop.disputeResolutionInd = prop.disputeResolutionInd
                ? prop.disputeResolutionInd
                : 0;
              return prop;
            })}
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
              fifthInfo,
              sixthInfo,
              seventhInfo,
            }}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName={accountReceivableNDCActivityLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            onFilterData={false}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={() => {
            commentsCallFn();
            commentsData(false, '');
          }}
          linkTableName="DRUG_ACTIVITY"
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default AccRecNDCActivity;
